import { parsePhoneNumber } from 'awesome-phonenumber';

const formatPhoneNumber = (phoneNumber, countryCode = 'US') => {
    var _a;
    if (!phoneNumber) {
        return '';
    }
    const pn = parsePhoneNumber(`${phoneNumber}`, { regionCode: countryCode });
    return ((_a = pn.number) === null || _a === void 0 ? void 0 : _a.national) || '';
};

export { formatPhoneNumber };
//# sourceMappingURL=formatPhoneNumber.js.map
